export default __webpack_public_path__ + "static/media/graphic_4.b95dc0e5.svg";